/** Payload for thermal receipt printing. */

export const RECEIPT_PRINTER_NOT_CONFIGURED = 'RECEIPT_PRINTER_NOT_CONFIGURED';

export interface ThermalReceiptLine {
  name: string;
  quantity: number;
  /** Unit price TTC shown in the Prix U. column. */
  unitPriceTtc: number;
  lineTotalTtc: number;
  /** Product-level remise TTC (shown on the line below the article). */
  productDiscountTtc?: number;
  productDiscountPercentage?: number;
}

export interface ThermalReceiptData {
  storeName?: string;
  branchName: string;
  receiptId: string;
  createdAt: string;
  cashierName: string;
  lines: ThermalReceiptLine[];
  subtotal: number;
  /** Total remise TTC (product + cart). */
  discountAmount: number;
  /** Remise panier TTC only (shown under the table when > 0). */
  cartDiscountAmount?: number;
  /** Remise panier % (optional label). */
  cartDiscountPercentage?: number;
  taxAmount?: number;
  grandTotal: number;
  paymentMethod: string;
  cashGiven?: number;
  cashReturned?: number;
  currencyCode?: string;
  /** Register / caisse number shown on ticket (default `1`). */
  registerNumber?: string;
  /** Short cashier id on ticket (defaults to cashierName). */
  cashierLabel?: string;
  /** Ticket display number e.g. `12` (derived from receiptId when omitted). */
  ticketLabel?: string;
}

/** Thermal receipt paper width bound in terminal setup. */
export type ReceiptPaperSize = '58mm' | '80mm';

/** All selectable paper sizes (narrowest first). */
export const RECEIPT_PAPER_SIZES: readonly ReceiptPaperSize[] = [
  '58mm',
  '80mm',
] as const;

export const DEFAULT_RECEIPT_PAPER_SIZE: ReceiptPaperSize = '80mm';

export function isReceiptPaperSize(value: unknown): value is ReceiptPaperSize {
  return value === '58mm' || value === '80mm';
}

export interface ReceiptPrinterConfig {
  printerName: string;
  configuredAt: string;
  configuredBy: string;
  /** ESC/POS layout profile; defaults to 80mm when omitted (legacy configs). */
  paperSize?: ReceiptPaperSize;
}

export type CupsPrinterStatus = 'idle' | 'printing' | 'disabled' | 'unknown';

export interface CupsPrinterInfo {
  name: string;
  status: CupsPrinterStatus;
}

export function formatThermalReceiptDate(
  date: Date,
  locale = 'fr-TN',
): string {
  const d = date.toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const t = date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${d} ${t}`;
}
